import React from 'react';
import { motion } from 'framer-motion';
import { ArrowUpRight, CircleCheck } from 'lucide-react';
import { SocialProof } from './SocialProof';
import { ClientLogos } from './ClientLogos';
import { useLanguage } from '../contexts/LanguageContext';
import { DEMO_URL } from '../data/links';
export function Hero() {
  const {
    t
  } = useLanguage();
  return <section className="relative px-5 pb-10 pt-12 sm:px-6 sm:pt-16 lg:pb-14 lg:pt-20" data-id="element-110" data-mp="4jm4pkalevoz">
      <motion.div initial={{
      opacity: 0,
      y: 16
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.5,
      ease: [0.22, 1, 0.36, 1]
    }} className="mx-auto max-w-[870px] text-center" data-id="element-111" data-mp="128pixfs3x15m">
        <h1 className="mx-auto max-w-[870px] font-hero text-[36px] font-medium leading-[1.15] tracking-[-0.01em] text-blue-reways-950-lock sm:text-5xl lg:text-[56px]" data-id="element-112" data-mp="sd4bv386lap0">
          <span className="relative inline-block text-[#F2A007]" data-id="element-113" data-mp="3d33fj0i70xlt">
            <span aria-hidden="true" className="absolute -inset-x-[0.14em] inset-y-[0.06em] rounded-[0.05em]" style={{
            background: 'linear-gradient(90deg, rgba(248,164,0,0.42) 0%, rgba(248,164,0,0.30) 45%, rgba(248,164,0,0.06) 88%, rgba(248,164,0,0) 100%)'
          }} data-id="element-114" data-mp="3825y4q50c7ld" />
            <span className="relative" data-id="element-115" data-mp="39cpfl1np9x62">{t.hero.highlight}</span>
          </span>{' '}
          {t.hero.titleRest}
        </h1>

        <p className="mx-auto mt-6 max-w-[620px] text-[15px] leading-[1.7] text-grey-800-lock sm:text-base" data-id="element-116" data-mp="30hhovkt9n8yh">
          {t.hero.subtitleBefore}{' '}
          <strong className="font-semibold text-blue-reways-950-lock" data-id="element-117" data-mp="35a2hij0frg0f">
            {t.hero.subtitleStrong}
          </strong>{' '}
          {t.hero.subtitleAfter}
        </p>

        <div className="mt-8 flex flex-col items-center gap-4" data-id="element-118" data-mp="2vjq02znx42yi">
          <SocialProof data-id="element-119" data-mp="2hin9qapw46hs" />

          <a href={DEMO_URL} target="_blank" rel="noopener noreferrer" className="inline-flex w-full items-center justify-center gap-2 rounded-xl bg-blue-reways-950-lock px-6 py-3.5 text-base font-medium text-white transition-opacity hover:opacity-90 focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-reways-500 sm:w-auto" data-id="element-120" data-mp="2hk85u4rurxhr">
            {t.cta.demo}
            <ArrowUpRight className="h-4 w-4 text-orange-rewayz-500" aria-hidden="true" data-id="element-121" data-mp="ichy92uaue3j" />
          </a>
          <p className="flex items-center gap-1.5 text-[13px] text-grey-800-lock" data-id="element-122" data-mp="deyitzlv7va0">
            <CircleCheck className="h-3.5 w-3.5" aria-hidden="true" data-id="element-123" data-mp="1b0drtyoknpw3" />
            {t.hero.demoDuration}
          </p>
        </div>
      </motion.div>

      <ClientLogos data-id="element-124" data-mp="112g4reig7z52" />
    </section>;
}